import App from "./App";

const Main = () => {
  return <App />;
};

export default Main;
